let delayedCalendlyCallTimeout = null;
export default {
    methods: {
        filterBlogs(categoryId) {
            if (categoryId === 'all') {
                this.selectedCategory = null;
                this.blogs = this.originalBlogs;
                return;
            }

            this.selectedCategory = categoryId;
            this.blogs = this.originalBlogs.filter((blog) => {
                return blog.category.some((c) => {
                    return c.id === categoryId;
                })
            })
        },
        showCalendly(){
            if(delayedCalendlyCallTimeout){
                clearTimeout(delayedCalendlyCallTimeout)
            }

            if(typeof Calendly !== "undefined"){
                Calendly.showPopupWidget('https://calendly.com/startupfalcon/demo/20min?month=2021-03&date=2021-03-03&back=1')
            }
            else {
                delayedCalendlyCallTimeout = setTimeout(function () {
                    if (typeof Calendly !== "undefined") {
                        Calendly.showPopupWidget('https://calendly.com/salesstartupfalcon/20min?month=2021-03&date=2021-03-03&back=1')
                    }
                }, 500);
            }

        }
    }
}
